import React, { useState } from "react";

const Card_Services = ({ cardData }) => {
  const [viewMoreStates, setViewMoreStates] = useState(
    Array(cardData.cards.length).fill(false)
  );

  const toggleViewMore = (index) => {
    setViewMoreStates((prevStates) =>
      prevStates.map((state, i) => (i === index ? !state : state))
    );
  };
  return (
    <div className="w-full flex justify-center mt-5">
      <div className="w-full flex gap-14 flex-col sm:w-full md:w-full   px-2 md:px-0">
        {/* Card  */}

        <div className=" flex   justify-evenly gap-10  xl:gap-0 items-center flex-wrap">
          {cardData.cards.map((data, index) => (
            <div
              key={index}
              className=" w-[300px] bg-white px-3  py-4 rounded-md flex flex-col justify-center items-center "
            >
              <div className=" flex flex-col items-center justify-center gap-3">
                {/* Logo */}
                <div className=" flex flex-col items-center justify-center">
                  <img
                    src={data.image}
                    alt={data.alt}
                    className=" text-black h-[50px]"
                  />
                </div>
                <div className=" flex  flex-col justify-center items-center">
                  <div>
                    <h3 className=" text-[18px]  text-center">{data.title}</h3>
                  </div>
                  {/* Content */}
                  <div
                    className={`overflow-y-auto  h-[80px] no-scrollbar ${
                      viewMoreStates[index]
                        ? " h-[80px] overflow-y-auto"
                        : "overflow-hidden"
                    }`}
                  >
                    <p className=" text-center text-[14px] text-[#6d6e70]  ">
                      {data.message}
                    </p>
                  </div>
                  <span>
                    {viewMoreStates[index] ? (
                      <span className="text-[#969ca6]">
                        <button onClick={() => toggleViewMore(index)}>
                          View Less
                        </button>
                      </span>
                    ) : (
                      <span className="text-[#969ca6]">
                        <button onClick={() => toggleViewMore(index)}>
                          View More
                        </button>
                      </span>
                    )}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Card_Services;
